<template>
	<!-- 导航条 -->
  <div id="naviagation" class="naviagation">
		<div class="navigate">
			<ul>
				<li v-for="(item,index) in naviagation" :key="item.name" :class="{active:navi===index}" @click="navi=index"><router-link :to="{path:item.url}">{{item.name}}</router-link></li>
        <!-- <li v-for="(item,index) in naviagation" :key="item.name" :class="{active:navi===index}" @click="navi=index"><a @click="toto(item)">{{item.name}}</a></li> -->
			</ul>
		</div>
	</div>
</template>
<script>
import router from '@/router/index'
import $ from 'jquery'
import Swiper from 'swiper'
import axios from 'axios'
import { mixin } from "../../../assets/script/scrollnav"
import { pagination } from '../../../../src/assets/mixin/data-table'

export default {
	name:'academicCircle',
  mixins: [pagination],
	data(){
		return{
      navi:'',
      naviagation:[
        {
          name:'首页',
          url:'/home'
        },
        {
          name:'期刊简介',
          // 杂志沿革
          url:'/Introduction'
        },
        {
          name:'编委会',
          // 编委风采
          url:'/editorial'
        },
        {
          name:'通知公告',
          // 历届会议
          url:'/fuwaheart'
        },
        // {
        //   name:' 过刊浏览',
        //   //
        //   url:'/Journal'
        // },
              {
          name:'期刊订阅',
          url:'subscription'
        },
        // {
        //   name:'指南与共识',
        //   url:'/according'
        // },
        {
          name:'下载专区',
          // 编辑掠影
          url:'/guidelines'
        },
 {
          name:'中国南方血管大会',
          // 编辑掠影
          url:'/convention'
        },
        // {
        //   name:'外科天地',
        //   url:'/datadown'
        // },
        {
          name:'联系我们',
          url:'/contactus'
        },
        // {
        //   name:'English',
        //   url:'/english'
        // }
      ]
		}
  },
  methods:{

  },
  components:{

  },
  created(){

  },
}
</script>

<style lang="less" scoped>
	#naviagation{
		width:100%;
    height:48px;
     background:#b80000;
		.navigate{
			width:1200px;
			height:100%;
			margin:0 auto;
      position:relative;
			.active{
				a{
          background:#fff;
          color: #b80000!important;
				}
			}
			ul{
				width:100%;
        height:100%;
        overflow: hidden;
        overflow-x: auto;
        display: flex;
        justify-content: space-between;
				li:last-child{
					margin-right:0px;
				}
				li{
					list-style:none;
					height:50px;
					line-height:50px;
					text-align:center;
					cursor:pointer;
          margin-right:10px;
          position: relative;
          top: -1px;
					a{
            padding:0 10px;
						display:block;
						width:100%;
						height:98%;
						color:#fff;
            font-size:18px;
					}
				}
			}
		}
  }
  @media screen and (max-width:1010px){
    #naviagation{
      display: none;
    }
  }
	.router-link-active{
    background: #fff;
    color: #b80000!important;
	}
</style>



// WEBPACK FOOTER //
// src/components/public/naviagation/index.vue